import React, { useState, createContext, useContext } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import "./HomeLayout.css";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Logo } from "../../components/logo/Logo";
import PermContactCalendarOutlinedIcon from "@mui/icons-material/PermContactCalendarOutlined";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import dec from "../../assets/landing/dec.svg";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import MailOutlinedIcon from "@mui/icons-material/MailOutlined";
import KeyboardDoubleArrowRightOutlinedIcon from "@mui/icons-material/KeyboardDoubleArrowRightOutlined";
import KeyboardDoubleArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardDoubleArrowLeftOutlined";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import Groups2OutlinedIcon from "@mui/icons-material/Groups2Outlined";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import ChecklistOutlinedIcon from "@mui/icons-material/ChecklistOutlined";

// Create context for sharing modal state
export const AddEventContext = createContext();

const navItems = [
  {
    name: "Home",
    path: "/home",
    logo: <HomeRoundedIcon />,
  },
  {
    name: "Calendar",
    path: "/home/events",
    logo: <CalendarMonthOutlinedIcon />,
  },
  { name: "Tasks", path: "/home/tasks", logo: <ChecklistOutlinedIcon /> },
  { name: "Meetings", path: "/home/meeting", logo: <HeadsetMicOutlinedIcon /> },
  { name: "Inbox", path: "/home/inbox", logo: <MailOutlinedIcon /> },
  { name: "Insights", path: "/home/insights", logo: <InsightsOutlinedIcon /> },
  { name: "Pre-Call Insights", path: "/home/pre-call-insights", logo: <LightbulbOutlinedIcon /> },
  { name: "Organization", path: "/home/team", logo: <Groups2OutlinedIcon /> },
  {
    name: "Contacts",
    path: "/home/clientonboarding",
    logo: <PermContactCalendarOutlinedIcon />,
  },
  { name: "Settings", path: "/home/settings", logo: <SettingsOutlinedIcon /> },
];

function SidebarContent({
  onClickNav,
  collapsed,
  sidebarOpen,
  isMobile,
  setSidebarOpen,
}) {
  const { name } = JSON.parse(localStorage.getItem("userData"));
  const role = (JSON.parse(localStorage.getItem("userData") || "{}")?.role || "").toString().toLowerCase();
  const navigate = useNavigate();
  const { setShowAddEventModal } = useContext(AddEventContext);

  const handleAddNew = () => {
    // Navigate to calendar and open add event modal
    navigate("/home/events");
    // Small delay to ensure navigation completes
    setTimeout(() => {
      setShowAddEventModal(true);
    }, 100);
  };

  const handleProfileBtn = () => {
    navigate("/home/settings");
  };

  return (
    <>
      <div className="sidebar-top">
        <img src={ dec } className="svg_nav" alt="Decorative background shape" />
        <div className="logo_div">
          { !collapsed && (
            <Logo
              variant="sidebar"
              className="sidebar-logo-component"
            />
          ) }
          { !isMobile && (
            <IconButton
              className="sidebar-toggle-btn"
              onClick={ () => setSidebarOpen((open) => !open) }
              style={ {
                borderRadius: 8,
                border: "2px solid #fff",
                position: "absolute",
                right: "4px",
                top: "50%",
                transform: "translateY(-50%)",
              } }
              size="small"
            >
              { collapsed ? (
                <KeyboardDoubleArrowRightOutlinedIcon
                  style={ { color: "#fff" } }
                />
              ) : (
                <KeyboardDoubleArrowLeftOutlinedIcon
                  style={ { color: "#fff" } }
                />
              ) }
            </IconButton>
          ) }
        </div>
        <img src={ dec } className="svg_nav_1" alt="Decorative background shape" />
        { !collapsed && (
          <button
            className="sidebar-add-btn"
            onClick={ handleAddNew }
            style={ { cursor: "pointer" } }
          >
            + Add New
          </button>
        ) }
        <nav
          className="sidebar-nav"
          style={ {
            margin: "",
            marginTop: collapsed ? "1rem" : "",
          } }
        >
          { navItems.map((item) => (
            // Don't show Uploads or Meta Leads links to members
            (role === "member" && item.path === "/home/meta-leads") ? null : (
              <NavLink
                key={ item.name }
                to={ item.path }
                className={ ({ isActive }) =>
                  isActive ? "sidebar-link active" : "sidebar-link"
                }
                end={ item.path === "/home" }
                onClick={ onClickNav }
                style={
                  collapsed
                    ? { justifyContent: "center", padding: "10px 10px" }
                    : {}
                }
              >
                { item.logo }
                { !collapsed && item.name }
              </NavLink>
            )
          )) }
        </nav>
      </div>
      <div className="sidebar-bottom">
        <div className="sidebar-user" onClick={ handleProfileBtn }>
          <div className="sidebar-avatar">
            { name?.toUpperCase().split("")[0] }
          </div>

          { !collapsed && (
            <div>
              <div className="sidebar-user-name">{ name }</div>
            </div>
          ) }
        </div>
      </div>
    </>
  );
}

export default function HomeLayout() {
  const isMobile = useMediaQuery("(max-width:900px)");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false); // for desktop
  const [showAddEventModal, setShowAddEventModal] = useState(false);

  return (
    <AddEventContext.Provider
      value={ { showAddEventModal, setShowAddEventModal } }
    >
      <div className="home-layout-root">
        { isMobile ? (
          <>
            <IconButton
              className="sidebar-mobile-menu"
              onClick={ () => setDrawerOpen(true) }
              style={ { position: "fixed", top: 18, left: 18, zIndex: 1301 } }
              size="large"
            >
              <MenuIcon style={ { color: "#151d3b" } } />
            </IconButton>
            <Drawer
              anchor="left"
              open={ drawerOpen }
              onClose={ () => setDrawerOpen(false) }
              PaperProps={ {
                style: {
                  width: 210,
                  background: "var(--primary-color)",
                  color: "#fff",
                },
              } }
            >
              <div
                style={ {
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                } }
              >
                <SidebarContent
                  onClickNav={ () => setDrawerOpen(false) }
                  sidebarOpen={ sidebarOpen }
                  setSidebarOpen={ setSidebarOpen }
                  isMobile={ isMobile }
                />
              </div>
            </Drawer>
          </>
        ) : (
          <aside
            className={ sidebarOpen ? "sidebar" : "sidebar sidebar-collapsed" }
          >
            <SidebarContent
              collapsed={ !sidebarOpen }
              sidebarOpen={ sidebarOpen }
              setSidebarOpen={ setSidebarOpen }
              isMobile={ isMobile }
            />
          </aside>
        ) }
        <main className="main-content">
          <Outlet />
        </main>
      </div>
    </AddEventContext.Provider>
  );
}